import type { DatabaseSchema, ViewDef } from '@nexus/core';

/**
 * A schema change: a new schema, or (better) a function applied to the latest
 * stored schema, so quick successive edits never build on a stale copy.
 */
export type SchemaChange = DatabaseSchema | ((latest: DatabaseSchema) => DatabaseSchema);
export type Save = (change: SchemaChange) => void;

/** The current version of `view` inside `schema`. */
export const viewIn = (schema: DatabaseSchema, view: ViewDef): ViewDef =>
  schema.views.find((v) => v.id === view.id) ?? view;
